import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Transform Better e-kitabı — Türkçe.
 *
 * Bölüm sırası, görseller ve beş başlık İngilizcesiyle birebir aynı; değişen
 * yalnızca nasıl söylendiği. Kapaktaki iki kelime ("Transform / Better")
 * çevrilmiyor: e-kitabın adı ve kapağın üzerinde basılı olan lettering o.
 * Altındaki cümle Türkçe, çünkü o bir vaat, isim değil.
 *
 * İndirilen dosya İngilizce — e-kitabın Türkçesi yok. Bu, sayfayı Türkçe
 * yazmamak için bir sebep değil: sayfayı okuyup indirme kararını veren kişi
 * Türkiye'deki okur, ve karar Türkçe veriliyor.
 */
export const ebookTransformBetter: WrittenPage = {
  navLabel: 'Transform Better',
  title: 'Transform Better: e-kitap',
  description:
    'Yüzlerce şirkete dönüşümlerinde eşlik ederken öğrendiğimiz beş kritik ders. Transform Better e-kitabını indirin.',
  sections: [
    {
      kind: 'cover',
      lines: ['Transform', 'Better'],
      sub: 'Dönüşümde başarı mümkün.',
      photo: {
        src: '/photo/transform-better-cover.webp',
        alt: 'Alacakaranlıkta virajlı bir dağ yolu; geçen araçların farları ormanın içinde uzun ışık şeritlerine dönüşmüş.',
      },
    },
    {
      kind: 'prose',
      align: 'center',
      paragraphs: [
        'İşinizin geleceğinin anahtarlarını, başarılı dijital dönüşüm için hazırladığımız kapsamlı '
          + 'rehberde bulun. Digitopia\'nın yüzlerce şirkete dönüşümleri boyunca eşlik ederken '
          + 'edindiği içgörülerle yazıldı. Dijital dönüşümün karmaşık coğrafyasında yolunuzu '
          + 'bulmanızı sağlayacak beş kritik dersi keşfedin. E-kitap, başarıya giden yolu '
          + 'aydınlatan kanıtlanmış stratejileri ve gerçek vaka çalışmalarını ele alıyor. İster '
          + 'yolu uzun bir girişimci olun ister meraklı bir yeni gelen, potansiyelinizi açığa '
          + 'çıkarmak ve kurumunuzu dönüştürmek için gereken araçlar burada.',
      ],
      cta: { label: 'Raporu indirin', href: LINKS.transformBetterEbookPdf },
    },
    {
      kind: 'banner',
      lines: ['5 Best', 'Practices'],
      photo: {
        src: '/photo/transform-better-five-best-practices.webp',
        alt: '5 Best Practices: mavi-pembe gradyan bir kartın üzerinde duran üç boyutlu cam bir 5 rakamı.',
      },
    },
    {
      kind: 'split',
      flip: true,
      heading: 'Dönüşüm bir yolculuktur.',
      paragraphs: [
        'Dijital dönüşüm, kurumu teknoloji entegrasyonu, kültürel değişim ve süreç iyileştirmeleri '
          + 'üzerinden yeniden şekillendiren, sonu olmayan bir yolculuktur. Varılacak bir yer '
          + 'değil, müşteri deneyimini, operasyonel verimliliği ve inovasyonu sürekli ileri taşıyan '
          + 'bir evrimdir. Bu yolculuğu benimseyen şirket dijital çağda uzun vadeli büyümeyi ve '
          + 'rekabet gücünü birlikte kazanır.',
      ],
      photo: {
        src: '/photo/sailing-boat-open-sea.webp',
        alt: 'Açık denizde, yelkenleri tam dolu bir tekne; yukarıdan görünüyor.',
      },
      cta: { label: 'Raporu indirin', href: LINKS.transformBetterEbookPdf },
    },
    {
      kind: 'split',
      heading: 'Dönüşüm bir takım sporudur.',
      paragraphs: [
        'Dijital dönüşüm ortak emekle yürür. Stratejiyi kuran liderlikten teknolojiyi sahaya alan '
          + 'IT\'ye kadar bölümler arası iş birliği gerektirir. Kültürel değişimi tek bir takım '
          + 'taşır: iş yapış biçimlerini yeni araçlara uyarlar, inovasyonu besler. Başarı, farklı '
          + 'yetkinlikleri ve bakış açılarını tek bir vizyonda hizalamakta; kurumu dijital olarak '
          + 'güçlü bir geleceğe orada taşırsınız.',
      ],
      photo: {
        src: '/photo/volleyball-block-at-the-net.webp',
        alt: 'Filenin üzerinde aynı topa uzanan iki voleybolcu.',
      },
      cta: { label: 'Raporu indirin', href: LINKS.transformBetterEbookPdf },
    },
    {
      kind: 'split',
      flip: true,
      heading: 'Dönüşüm bir kurum meselesidir.',
      paragraphs: [
        'Dijital dönüşüm tek tek rollerin üstünde bir konudur; kurumsal bir zorunluluktur. İş '
          + 'modelini yeniden kurar; kültürel değişimi sürüklemek ve kaynak ayırmak için liderliğin '
          + 'taahhüdünü ister. Müşteri temasından operasyona kadar her alan bundan etkilenir. Bu '
          + 'bütünsel değişimi benimseyen kurum dijital çağda hem ayakta kalır hem rekabet gücünü '
          + 'korur.',
      ],
      photo: {
        src: '/photo/boardroom-applause-dashboards.webp',
        alt: 'Performans panolarını sunan meslektaşını alkışlayan bir toplantı odası.',
      },
      cta: { label: 'Raporu indirin', href: LINKS.transformBetterEbookPdf },
    },
    {
      kind: 'split',
      heading: 'Dönüşüm odak ister.',
      paragraphs: [
        'Dijital dönüşüm şaşmaz bir odak ister. Kaynağın stratejik dağıtımı ve girişimlerin '
          + 'önceliklendirilmesi işin merkezindedir. Teknolojinin karmaşıklığı içinde hedefi net '
          + 'tutmak, hem uygulamayı hem etkiyi belirler. Dar bir odak kurumu başarılı bir dijital '
          + 'evrime taşır; kazananla kaybedeni ayıran şey bilinçli kararlar ve isabetli icradır.',
      ],
      photo: {
        src: '/photo/woman-in-crowd-city-street.webp',
        alt: 'Kalabalık bir cadde arkasında bulanıklaşırken bir yana sabit bakan bir kadın.',
      },
      cta: { label: 'Raporu indirin', href: LINKS.transformBetterEbookPdf },
    },
    {
      kind: 'split',
      flip: true,
      heading: 'Ölçülen şey yapılır.',
      paragraphs: [
        'Metrikler ilerlemeyi görünür kılar; güçlü yanları da ilgi bekleyen alanları da ortaya '
          + 'çıkarır. KPI takibi hedeflerle hizayı korur ve kararları veriye dayandırır. Bu '
          + 'tekrarlanan döngü hesap verebilirliği artırır, uygulamayı hızlandırır ve dönüşüm '
          + 'girişimlerini gerçekten sonuca ulaştırır.',
      ],
      photo: {
        src: '/photo/airliner-cockpit-checklist.webp',
        alt: 'Kokpitte, göstergelere karşı kontrol listesini okuyan iki pilot.',
      },
      cta: { label: 'Raporu indirin', href: LINKS.transformBetterEbookPdf },
    },
    {
      kind: 'cta',
      tone: 'card',
      heading:
        'Dijital çağda başarının kapısını aralayın. Rehberinizi şimdi alın ve #transformbetter!',
      ctas: [{ label: 'Raporu indirin', href: LINKS.transformBetterEbookPdf }],
      photo: {
        src: '/photo/transform-better-ebook-covers.webp',
        alt: 'Yelpaze gibi dizilmiş dört Transform Better e-kitabı; kapakta dağ yolu.',
      },
    },
  ],
}
